// https://github.com/feathericons/react-feather

import { lazy } from 'react';

export * from './arrow-left';
export * from './arrow-right';
export * from './box';
export * from './calendar';
export * from './chevron-down';
export * from './chevron-left';
export * from './chevron-right';
export * from './eye-off';
export * from './eye';
export * from './facebook';
export * from './filter';
export * from './github';
export * from './grid';
export * from './hexagon';
export * from './instagram';
export * from './linkedin';
export * from './llm-ai';
export * from './llm-arrow-corner-right-up';
export * from './llm-arrow-left';
export * from './llm-arrow-right-up';
export * from './llm-arrow-right';
export * from './llm-arrow-up';
export * from './llm-aside';
export * from './llm-back';
export * from './llm-camera';
export * from './llm-check';
export * from './llm-chevron-right-circle';
export * from './llm-generate';
export * from './llm-idea';
export * from './llm-info-circle';
export * from './llm-itinerary';
export * from './llm-maximize';
export * from './llm-microphone';
export * from './llm-minimize';
export * from './llm-options';
export * from './llm-paperclip';
export * from './llm-pin';
export * from './llm-play';
export * from './llm-refresh';
export * from './llm-search';
export * from './llm-send';
export * from './llm-stop';
export * from './llm-timetable';
export * from './llm-trash';
export * from './llm-upload';
export * from './llm-volume-x';
export * from './llm-volume';
export * from './llm-x';
export * from './lock';
export * from './log-in';
export * from './log-out';
export * from './map-pin';
export * from './menu';
export * from './minus';
export * from './percent';
export * from './phone-call';
export * from './phone';
export * from './plus';
export * from './refresh-ccw';
export * from './search';
export * from './send';
export * from './shopping-cart';
export * from './square';
export * from './trash';
export * from './truck';
export * from './twitter';
export * from './unlock';
export * from './user';
export * from './webhook';
export * from './websolute';
export * from './x-circle';
export * from './x';

export const Icons = {
  IconArrowLeft: lazy(() => import('./arrow-left').then( module => ({ default: module.IconArrowLeft }) )),
  IconArrowRight: lazy(() => import('./arrow-right').then( module => ({ default: module.IconArrowRight }) )),
  IconBox: lazy(() => import('./box').then( module => ({ default: module.IconBox }) )),
  IconCalendar: lazy(() => import('./calendar').then( module => ({ default: module.IconCalendar }) )),
  IconChevronDown: lazy(() => import('./chevron-down').then( module => ({ default: module.IconChevronDown }) )),
  IconChevronLeft: lazy(() => import('./chevron-left').then( module => ({ default: module.IconChevronLeft }) )),
  IconChevronRight: lazy(() => import('./chevron-right').then( module => ({ default: module.IconChevronRight }) )),
  IconEyeOff: lazy(() => import('./eye-off').then( module => ({ default: module.IconEyeOff }) )),
  IconEye: lazy(() => import('./eye').then( module => ({ default: module.IconEye }) )),
  IconFacebook: lazy(() => import('./facebook').then( module => ({ default: module.IconFacebook }) )),
  IconFilter: lazy(() => import('./filter').then( module => ({ default: module.IconFilter }) )),
  IconGithub: lazy(() => import('./github').then( module => ({ default: module.IconGithub }) )),
  IconGrid: lazy(() => import('./grid').then( module => ({ default: module.IconGrid }) )),
  IconHexagon: lazy(() => import('./hexagon').then( module => ({ default: module.IconHexagon }) )),
  IconInstagram: lazy(() => import('./instagram').then( module => ({ default: module.IconInstagram }) )),
  IconLinkedin: lazy(() => import('./linkedin').then( module => ({ default: module.IconLinkedin }) )),
  IconLlmAi: lazy(() => import('./llm-ai').then( module => ({ default: module.IconLlmAi }) )),
  IconLlmArrowCornerRightUp: lazy(() => import('./llm-arrow-corner-right-up').then( module => ({ default: module.IconLlmArrowCornerRightUp }) )),
  IconLlmArrowLeft: lazy(() => import('./llm-arrow-left').then( module => ({ default: module.IconLlmArrowLeft }) )),
  IconLlmArrowRightUp: lazy(() => import('./llm-arrow-right-up').then( module => ({ default: module.IconLlmArrowRightUp }) )),
  IconLlmArrowRight: lazy(() => import('./llm-arrow-right').then( module => ({ default: module.IconLlmArrowRight }) )),
  IconLlmArrowUp: lazy(() => import('./llm-arrow-up').then( module => ({ default: module.IconLlmArrowUp }) )),
  IconLlmAside: lazy(() => import('./llm-aside').then( module => ({ default: module.IconLlmAside }) )),
  IconLlmBack: lazy(() => import('./llm-back').then( module => ({ default: module.IconLlmBack }) )),
  IconLlmCamera: lazy(() => import('./llm-camera').then( module => ({ default: module.IconLlmCamera }) )),
  IconLlmCheck: lazy(() => import('./llm-check').then( module => ({ default: module.IconLlmCheck }) )),
  IconLlmChevronRightCircle: lazy(() => import('./llm-chevron-right-circle').then( module => ({ default: module.IconLlmChevronRightCircle }) )),
  IconLlmGenerate: lazy(() => import('./llm-generate').then( module => ({ default: module.IconLlmGenerate }) )),
  IconLlmIdea: lazy(() => import('./llm-idea').then( module => ({ default: module.IconLlmIdea }) )),
  IconLlmInfoCircle: lazy(() => import('./llm-info-circle').then( module => ({ default: module.IconLlmInfoCircle }) )),
  IconLlmItinerary: lazy(() => import('./llm-itinerary').then( module => ({ default: module.IconLlmItinerary }) )),
  IconLlmMaximize: lazy(() => import('./llm-maximize').then( module => ({ default: module.IconLlmMaximize }) )),
  IconLlmMicrophone: lazy(() => import('./llm-microphone').then( module => ({ default: module.IconLlmMicrophone }) )),
  IconLlmMinimize: lazy(() => import('./llm-minimize').then( module => ({ default: module.IconLlmMinimize }) )),
  IconLlmOptions: lazy(() => import('./llm-options').then( module => ({ default: module.IconLlmOptions }) )),
  IconLlmPaperclip: lazy(() => import('./llm-paperclip').then( module => ({ default: module.IconLlmPaperclip }) )),
  IconLlmPin: lazy(() => import('./llm-pin').then( module => ({ default: module.IconLlmPin }) )),
  IconLlmPlay: lazy(() => import('./llm-play').then( module => ({ default: module.IconLlmPlay }) )),
  IconLlmRefresh: lazy(() => import('./llm-refresh').then( module => ({ default: module.IconLlmRefresh }) )),
  IconLlmSearch: lazy(() => import('./llm-search').then( module => ({ default: module.IconLlmSearch }) )),
  IconLlmSend: lazy(() => import('./llm-send').then( module => ({ default: module.IconLlmSend }) )),
  IconLlmStop: lazy(() => import('./llm-stop').then( module => ({ default: module.IconLlmStop }) )),
  IconLlmTimetable: lazy(() => import('./llm-timetable').then( module => ({ default: module.IconLlmTimetable }) )),
  IconLlmTrash: lazy(() => import('./llm-trash').then( module => ({ default: module.IconLlmTrash }) )),
  IconLlmUpload: lazy(() => import('./llm-upload').then( module => ({ default: module.IconLlmUpload }) )),
  IconLlmVolumeX: lazy(() => import('./llm-volume-x').then( module => ({ default: module.IconLlmVolumeX }) )),
  IconLlmVolume: lazy(() => import('./llm-volume').then( module => ({ default: module.IconLlmVolume }) )),
  IconLlmX: lazy(() => import('./llm-x').then( module => ({ default: module.IconLlmX }) )),
  IconLock: lazy(() => import('./lock').then( module => ({ default: module.IconLock }) )),
  IconLogIn: lazy(() => import('./log-in').then( module => ({ default: module.IconLogIn }) )),
  IconLogOut: lazy(() => import('./log-out').then( module => ({ default: module.IconLogOut }) )),
  IconMapPin: lazy(() => import('./map-pin').then( module => ({ default: module.IconMapPin }) )),
  IconMenu: lazy(() => import('./menu').then( module => ({ default: module.IconMenu }) )),
  IconMinus: lazy(() => import('./minus').then( module => ({ default: module.IconMinus }) )),
  IconPercent: lazy(() => import('./percent').then( module => ({ default: module.IconPercent }) )),
  IconPhoneCall: lazy(() => import('./phone-call').then( module => ({ default: module.IconPhoneCall }) )),
  IconPhone: lazy(() => import('./phone').then( module => ({ default: module.IconPhone }) )),
  IconPlus: lazy(() => import('./plus').then( module => ({ default: module.IconPlus }) )),
  IconRefreshCcw: lazy(() => import('./refresh-ccw').then( module => ({ default: module.IconRefreshCcw }) )),
  IconSearch: lazy(() => import('./search').then( module => ({ default: module.IconSearch }) )),
  IconSend: lazy(() => import('./send').then( module => ({ default: module.IconSend }) )),
  IconShoppingCart: lazy(() => import('./shopping-cart').then( module => ({ default: module.IconShoppingCart }) )),
  IconSquare: lazy(() => import('./square').then( module => ({ default: module.IconSquare }) )),
  IconTrash: lazy(() => import('./trash').then( module => ({ default: module.IconTrash }) )),
  IconTruck: lazy(() => import('./truck').then( module => ({ default: module.IconTruck }) )),
  IconTwitter: lazy(() => import('./twitter').then( module => ({ default: module.IconTwitter }) )),
  IconUnlock: lazy(() => import('./unlock').then( module => ({ default: module.IconUnlock }) )),
  IconUser: lazy(() => import('./user').then( module => ({ default: module.IconUser }) )),
  IconWebhook: lazy(() => import('./webhook').then( module => ({ default: module.IconWebhook }) )),
  IconWebsolute: lazy(() => import('./websolute').then( module => ({ default: module.IconWebsolute }) )),
  IconXCircle: lazy(() => import('./x-circle').then( module => ({ default: module.IconXCircle }) )),
  IconX: lazy(() => import('./x').then( module => ({ default: module.IconX }) ))
};
